import { render } from "./OnboardingDocuments.vue?vue&type=template&id=1fb74214"
import script from "./OnboardingDocuments.vue?vue&type=script&lang=js"
export * from "./OnboardingDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__